import {inject, Injectable} from '@angular/core';
import {BookAppointmentsDto} from './dtos/book-appointments.dto';
import {Observable} from 'rxjs';
import {AppointmentResponseDto} from './dtos/appointment-response.dto';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  http = inject(HttpClient);

  bookAppointments(bookAppointmentDto: BookAppointmentsDto): Observable<AppointmentResponseDto[]> {
    return this.http.post<AppointmentResponseDto[]>(`${environment.cenplexBookingApiBaseUrl}/patients/${bookAppointmentDto.patientId}/appointments`, bookAppointmentDto);
  }
}
